module.exports = {
      id: "followus-usage",
      viewBox: "0 0 49 40",
      url: __webpack_public_path__ + "svg-sprite-3da3c54197bd9bf6e26a7217bd920efb.svg#followus",
      toString: function () {
        return this.url;
      }
    }